import Centrifuge from 'centrifuge'

export default (ctx, inject) => {
  const centrifuge = new Centrifuge(ctx.$config.wsChatEndpoint)
  inject('centrifuge', centrifuge)
}
